(function() {
   'use strict';

   window.TSC = window.TSC || {};

   window.TSC.smartPlayerPreRollEventConstants = (function() {
      return {
         PRE_ROLL_STARTED: 'preRollStarted',
         PRE_ROLL_FINISHED: 'preRollFinished',
         PRE_ROLL_FINISHED_ACTIONS: {
            REMOVE_NOW: 'removeNow'
         }
      };
   })();
})();